import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Process from "@/components/site/Process";
import ExperienceMarquee from "@/components/site/ExperienceMarquee";
import Gallery from "@/components/site/Gallery";
import QuoteForm from "@/components/site/QuoteForm";
import PhotoUploadSection from "@/components/site/PhotoUploadSection";
import Reviews from "@/components/site/Reviews";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative bg-hero-void text-white overflow-x-hidden">
      <Header />
      <Hero />
      <Manifesto />
      <Process />
      <ExperienceMarquee />
      <Gallery />
      <QuoteForm />
      <PhotoUploadSection />
      <Reviews />
      <Footer />
    </main>
  );
}
